module.exports = __webpack_public_path__ + "static/images/ico-lef-mess@2x.1e605bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/ico-lef-mess@2x.png
// module id = ecC3
// module chunks = 6 7